<template src="./template.html"></template>
<script>

export default {
  name: 'FooterRor',
  created() {
    //console.log(this.$supplier);
  },
  data() {
    return{
      globalSupplier: this.$supplier.links,
    }
  },
};

</script>

<style scoped>
  .ror_footer{
    background-color:#F9F7F7;
    border-top:none;
  }

  .ror_row{
    margin-left:0;
    margin-right:0;
  }

  p, a{
    font-size:14px;
    color:#000;
    font-weight: 300;
    font-family:'Helvetica', sans-serif
  }
</style>


// WEBPACK FOOTER //
// src/components/modules/04b_footer_ror/index.vue